import { browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from '@simplewebauthn/browser';

// Fingerprint/Face ID en el navegador (WebAuthn) solo funciona en contexto
// seguro: https, o http sobre localhost. Probar desde el celular contra la
// IP de la red local por http no va a mostrar el botón — hace falta el
// dominio real con https (ver docs/DEPLOY.md) o abrir la app por localhost.
export async function canUseFingerprintLogin(): Promise<boolean> {
  if (!browserSupportsWebAuthn()) return false;
  try {
    return await platformAuthenticatorIsAvailable();
  } catch {
    return false;
  }
}

// Nombre por defecto para la passkey nueva, así en Ajustes la lista de
// dispositivos con huella activada se puede reconocer a simple vista.
export function guessDeviceName(): string {
  const ua = navigator.userAgent;
  if (/iPhone/.test(ua)) return 'iPhone';
  if (/iPad/.test(ua)) return 'iPad';
  if (/Android/.test(ua)) return 'Teléfono Android';
  if (/Macintosh/.test(ua)) return 'Mac';
  if (/Windows/.test(ua)) return 'PC con Windows';
  return 'Este dispositivo';
}
